export default __webpack_public_path__ + "static/assets/634181e15852dd577557bb62a1e04ac8.svg";